module.exports = __webpack_public_path__ + "static/media/integrations.inactive.88de9ab3.svg";